<div class="cv-upload">

  <!-- Drop zone -->
  @if (!selectedFile()) {
    <div
      class="drop-zone"
      [class.dragging]="isDragging()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()"
      role="button"
      tabindex="0"
      aria-label="Upload CV — click or drag and drop"
      (keydown.enter)="fileInput.click()"
      (keydown.space)="fileInput.click()"
    >
      <i class="pi pi-upload drop-icon"></i>
      <p class="drop-primary">Drag &amp; drop a CV here</p>
      <p class="drop-secondary">or <span class="drop-link">browse to upload</span></p>
      <p class="drop-hint">Accepted: PDF, DOC, DOCX &nbsp;·&nbsp; Max 20 MB</p>
    </div>

    <input
      #fileInput
      type="file"
      accept=".pdf,.doc,.docx"
      class="hidden-input"
      (change)="onFileSelected($event)"
    />
  }

  <!-- Selected file preview -->
  @if (selectedFile(); as file) {
    <div class="file-preview">
      <div class="file-icon-wrap">
        <i class="pi pi-file-pdf file-icon"></i>
      </div>
      <div class="file-info">
        <span class="file-name">{{ file.name }}</span>
        <span class="file-size">{{ formatBytes(file.size) }}</span>
      </div>
      <button
        class="remove-btn"
        type="button"
        title="Remove file"
        (click)="removeFile()"
        [disabled]="isUploading()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  }

  <!-- Optional candidate details -->
  @if (selectedFile()) {
    <div class="candidate-fields">
      <div class="field">
        <label class="field-label" for="cv-candidate-name">Candidate name <span class="optional">(optional)</span></label>
        <input
          pInputText
          id="cv-candidate-name"
          type="text"
          placeholder="e.g. Jane Smith"
          [(ngModel)]="candidateName"
          [disabled]="isUploading()"
          class="field-input"
        />
      </div>
      <div class="field">
        <label class="field-label" for="cv-candidate-email">Candidate email <span class="optional">(optional)</span></label>
        <input
          pInputText
          id="cv-candidate-email"
          type="email"
          placeholder="e.g. jane@example.com"
          [(ngModel)]="candidateEmail"
          [disabled]="isUploading()"
          class="field-input"
        />
      </div>
    </div>

    <!-- Upload progress -->
    @if (isUploading()) {
      <div class="upload-progress">
        <p-progressbar mode="indeterminate" styleClass="upload-bar" />
        <span class="uploading-label">Uploading and queuing for processing…</span>
      </div>
    }

    <!-- Submit -->
    <div class="upload-actions">
      <p-button
        label="Upload CV"
        icon="pi pi-cloud-upload"
        [loading]="isUploading()"
        [disabled]="isUploading()"
        (click)="submit()"
      />
    </div>
  }

</div>
